/* eslint-disable */

<template>
  <div>
    <div class="vx-row">

      <div class="vx-col lg:w-4/12 md:w-5/12 sm:w-5/5 mb-4">
        <div class="flex gap-2 mb-2">
          <vs-button :color="sel==='gw1'?'primary':'grey'" type="filled" class="flex-1" @click="sel='gw1'">Gw1</vs-button>
          <vs-button :color="sel==='sw1'?'primary':'grey'" type="filled" class="flex-1" @click="sel='sw1'">Sw1</vs-button>
        </div>

        <vx-card style="height: 42rem; overflow-y: auto">
          <!-- Task 1 (Gw1) -->
          <div class="rounded-lg mb-3 overflow-hidden" :style="{border:'1px solid '+(task1Done?'#28C76F':'#3a3f51')}">
            <div class="flex items-center gap-2 px-3 py-2" :style="{background:task1Done?'rgba(40,199,111,0.08)':'rgba(255,255,255,0.03)'}">
              <span class="flex-shrink-0 rounded-full flex items-center justify-center font-bold text-white" :style="{width:'20px',height:'20px',fontSize:'10px',background:task1Done?'#28C76F':'#4a5568'}">1</span>
              <span class="font-semibold text-sm flex-1">Local Account &amp; Telnet VTY — Gw1</span>
              <span class="text-xs font-medium" :class="task1Done?'text-success':'text-grey'">{{ task1Items.filter(i=>gw1Completion[i.key]).length }}/{{ task1Items.length }}</span>
            </div>
            <div class="px-3 py-2 space-y-1">
              <div v-for="item in task1Items" :key="'t1-'+item.key" class="flex items-center gap-2">
                <div class="flex-shrink-0 rounded-full" :style="{width:'8px',height:'8px',background:gw1Completion[item.key]?'#28C76F':'transparent',border:'2px solid '+(gw1Completion[item.key]?'#28C76F':'#6b7280')}"></div>
                <code class="text-base" :class="gw1Completion[item.key]?'text-success':''">{{ item.cmd }}</code>
              </div>
            </div>
          </div>

          <!-- Task 2 (Gw1) -->
          <div class="rounded-lg mb-3 overflow-hidden" :style="{border:'1px solid '+(task2Done?'#28C76F':'#3a3f51')}">
            <div class="flex items-center gap-2 px-3 py-2" :style="{background:task2Done?'rgba(40,199,111,0.08)':'rgba(255,255,255,0.03)'}">
              <span class="flex-shrink-0 rounded-full flex items-center justify-center font-bold text-white" :style="{width:'20px',height:'20px',fontSize:'10px',background:task2Done?'#28C76F':'#4a5568'}">2</span>
              <span class="font-semibold text-sm flex-1">Named ACL CORP_ACL — Gw1</span>
              <span class="text-xs font-medium" :class="task2Done?'text-success':'text-grey'">{{ task2Items.filter(i=>gw1Completion[i.key]).length }}/{{ task2Items.length }}</span>
            </div>
            <div class="px-3 py-2 space-y-1">
              <div v-for="item in task2Items" :key="'t2-'+item.key" class="flex items-center gap-2">
                <div class="flex-shrink-0 rounded-full" :style="{width:'8px',height:'8px',background:gw1Completion[item.key]?'#28C76F':'transparent',border:'2px solid '+(gw1Completion[item.key]?'#28C76F':'#6b7280')}"></div>
                <code class="text-base" :class="gw1Completion[item.key]?'text-success':''">{{ item.cmd }}</code>
              </div>
            </div>
          </div>

          <!-- Task 3 (Sw1) -->
          <div class="rounded-lg mb-3 overflow-hidden" :style="{border:'1px solid '+(task3Done?'#28C76F':'#3a3f51')}">
            <div class="flex items-center gap-2 px-3 py-2" :style="{background:task3Done?'rgba(40,199,111,0.08)':'rgba(255,255,255,0.03)'}">
              <span class="flex-shrink-0 rounded-full flex items-center justify-center font-bold text-white" :style="{width:'20px',height:'20px',fontSize:'10px',background:task3Done?'#28C76F':'#4a5568'}">3</span>
              <span class="font-semibold text-sm flex-1">DHCP Snooping — Sw1</span>
              <span class="text-xs font-medium" :class="task3Done?'text-success':'text-grey'">{{ task3Items.filter(i=>sw1Completion[i.key]).length }}/{{ task3Items.length }}</span>
            </div>
            <div class="px-3 py-2 space-y-1">
              <div v-for="item in task3Items" :key="'t3-'+item.key" class="flex items-center gap-2">
                <div class="flex-shrink-0 rounded-full" :style="{width:'8px',height:'8px',background:sw1Completion[item.key]?'#28C76F':'transparent',border:'2px solid '+(sw1Completion[item.key]?'#28C76F':'#6b7280')}"></div>
                <code class="text-base" :class="sw1Completion[item.key]?'text-success':''">{{ item.cmd }}</code>
              </div>
            </div>
          </div>

          <!-- Save -->
          <div class="rounded-lg mb-2 overflow-hidden" :style="{border:'1px solid '+(saveDone?'#28C76F':'#3a3f51')}">
            <div class="flex items-center gap-2 px-3 py-2" :style="{background:saveDone?'rgba(40,199,111,0.08)':'rgba(255,255,255,0.03)'}">
              <feather-icon :icon="saveDone?'CheckCircleIcon':'CircleIcon'" :svgClasses="saveDone?'text-success':'text-grey'" size="16" class="flex-shrink-0" />
              <span class="font-semibold text-sm flex-1">Save Configuration</span>
              <span class="text-xs font-medium" :class="saveDone?'text-success':'text-grey'">{{ [gw1Completion.saved,sw1Completion.saved].filter(Boolean).length }}/2</span>
            </div>
            <div class="px-3 py-2">
              <div v-for="devKey in ['gw1','sw1']" :key="'s-'+devKey" class="mb-2">
                <span class="inline-block text-xs font-semibold px-2 py-px rounded mb-1" style="background:rgba(255,255,255,0.07);letter-spacing:.05em">{{ devKey.toUpperCase() }}</span>
                <div class="space-y-1 ml-1">
                  <div class="flex items-center gap-2">
                    <div class="flex-shrink-0 rounded-full" :style="{width:'8px',height:'8px',background:getState(devKey).endDone?'#28C76F':'transparent',border:'2px solid '+(getState(devKey).endDone?'#28C76F':'#6b7280')}"></div>
                    <code class="text-base" :class="getState(devKey).endDone?'text-success':''">end</code>
                  </div>
                  <div class="flex items-center gap-2">
                    <div class="flex-shrink-0 rounded-full" :style="{width:'8px',height:'8px',background:getCompletion(devKey).saved?'#28C76F':'transparent',border:'2px solid '+(getCompletion(devKey).saved?'#28C76F':'#6b7280')}"></div>
                    <code class="text-base" :class="getCompletion(devKey).saved?'text-success':''">copy running-config startup-config</code>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </vx-card>
      </div>

      <div class="vx-col lg:w-8/12 md:w-7/12 sm:w-5/5">
        <div style="height: 35rem">
          <vue-command v-show="sel==='gw1'" key="gw1" id="gw1_terminal" :commands="gw1Commands" :prompt="gw1Prompt" :show-intro="true" intro="Cisco IOS Software, Version 15.2(4)M1 — Type 'help' for available commands." style="background-color:#111111;border:1px solid #181d2a;border-radius:0.5rem;height:100%" title="Gw1" />
          <vue-command v-show="sel==='sw1'" key="sw1" id="sw1_terminal" :commands="sw1Commands" :prompt="sw1Prompt" :show-intro="true" intro="Cisco IOS Software, Version 15.2(4)M1 — Type 'help' for available commands." style="background-color:#111111;border:1px solid #181d2a;border-radius:0.5rem;height:100%" title="Sw1" />
        </div>

        <!-- Topology -->
        <div class="topology-card">
          <img :src="topologyImage" alt="Network topology" class="topology-img" />
        </div>
      </div>

    </div>
  </div>
</template>

<script>
/* eslint-disable */
import VueCommand, { createStdout, createStderr } from 'vue-command';
import 'vue-command/dist/vue-command.css';

const HELP = 'Type commands as shown in the task checklist.';

const SHOW_IFACE_BRIEF =
  'Interface&nbsp;&nbsp;&nbsp;&nbsp;IP-Address&nbsp;&nbsp;&nbsp;OK?&nbsp;Method&nbsp;Status&nbsp;&nbsp;&nbsp;Protocol<br>' +
  'Ethernet0/0&nbsp;&nbsp;10.1.1.1&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;YES&nbsp;NVRAM&nbsp;&nbsp;up&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;up<br>' +
  'Ethernet0/1&nbsp;&nbsp;10.10.10.1&nbsp;&nbsp;&nbsp;YES&nbsp;NVRAM&nbsp;&nbsp;up&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;up<br>';

const SHOW_DHCP_SNOOP =
  'Switch DHCP snooping is enabled<br>' +
  'DHCP snooping is configured on following VLANs: 10<br>' +
  'Insertion of option 82 is disabled<br>' +
  'Option 82 on untrusted port is not allowed<br>' +
  'Verification of hwaddr field is enabled<br>' +
  'Interface&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Trusted&nbsp;&nbsp;&nbsp;&nbsp;Rate limit (pps)<br>' +
  '---------&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;-------&nbsp;&nbsp;&nbsp;&nbsp;----------------<br>' +
  'Ethernet0/1&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;yes&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;unlimited<br>' +
  'Ethernet0/2&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;yes&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;unlimited<br>';

export default {
  data() {
    return {
      dataLocal: JSON.parse(JSON.stringify(this.data)),
      topologyImage: 'https://ip-learn.b-cdn.net/simulations/ccna-topologies/Named_Access_list_DHCP_Snooping_Sim.png',
      sel: 'gw1',
      totalScore: 0,

      task1Items: [
        { key: 'username',       cmd: 'username wheel privilege 15 algorithm-type scrypt secret lock3path' },
        { key: 'lineVty',        cmd: 'line vty 0 4' },
        { key: 'transportTelnet',cmd: 'transport input telnet' },
        { key: 'loginLocal',     cmd: 'login local' },
        { key: 'vtyExited',      cmd: 'exit' },
        { key: 'endForVerify',   cmd: 'end' },
        { key: 'verifyShowIp',   cmd: 'show ip interface brief' },
      ],
      task2Items: [
        { key: 'aclCreated',   cmd: 'ip access-list extended CORP_ACL' },
        { key: 'permitBootpc', cmd: 'permit udp any any eq bootpc' },
        { key: 'permitBootps', cmd: 'permit udp any any eq bootps' },
        { key: 'permitHttps',  cmd: 'permit tcp 10.10.10.0 0.0.0.255 any eq 443' },
        { key: 'denyIp',       cmd: 'deny ip 10.10.10.0 0.0.0.255 any log-input' },
        { key: 'aclExited',    cmd: 'exit' },
        { key: 'intE00',       cmd: 'interface e0/0' },
        { key: 'accessGroup',  cmd: 'ip access-group CORP_ACL in' },
      ],
      task3Items: [
        { key: 'dhcpSnooping',     cmd: 'ip dhcp snooping' },
        { key: 'dhcpSnoopingVlan', cmd: 'ip dhcp snooping vlan 10' },
        { key: 'noInfoOption',     cmd: 'no ip dhcp snooping information option' },
        { key: 'verifyMac',        cmd: 'ip dhcp snooping verify mac-address' },
        { key: 'intE01',           cmd: 'interface e0/1' },
        { key: 'trustE01',         cmd: 'ip dhcp snooping trust' },
        { key: 'intE02',           cmd: 'interface e0/2' },
        { key: 'trustE02',         cmd: 'ip dhcp snooping trust' },
        { key: 'endForVerify',     cmd: 'end' },
        { key: 'verifyShow',       cmd: 'show ip dhcp snooping' },
      ],

      gw1: { mode: 'exec', currentInterface: null, currentAcl: null, endDone: false },
      sw1: { mode: 'exec', currentInterface: null, endDone: false },

      gw1Completion: {
        username: false, lineVty: false, transportTelnet: false, loginLocal: false,
        vtyExited: false, endForVerify: false, verifyShowIp: false,
        aclCreated: false, permitBootpc: false, permitBootps: false,
        permitHttps: false, denyIp: false, aclExited: false,
        intE00: false, accessGroup: false, saved: false,
      },
      sw1Completion: {
        dhcpSnooping: false, dhcpSnoopingVlan: false, noInfoOption: false, verifyMac: false,
        intE01: false, trustE01: false, intE02: false, trustE02: false,
        endForVerify: false, verifyShow: false, saved: false,
      },

      gw1Commands: {
        help:      () => createStdout(HELP),
        enable:    () => createStdout(''),
        configure: (x) => this.gw1Configure(x),
        conf:      (x) => this.gw1Configure(x),
        exit:      () => this.gw1Exit(),
        end:       () => this.gw1End(),
        username:  (x) => this.gw1Username(x),
        line:      (x) => this.gw1Line(x),
        transport: (x) => this.gw1Transport(x),
        login:     (x) => this.gw1Login(x),
        ip:        (x) => this.gw1Ip(x),
        permit:    (x) => this.gw1Permit(x),
        deny:      (x) => this.gw1Deny(x),
        interface: (x) => this.gw1Interface(x),
        int:       (x) => this.gw1Interface(x),
        show:      (x) => this.gw1Show(x),
        copy:      (x) => this.gw1Copy(x),
      },
      sw1Commands: {
        help:      () => createStdout(HELP),
        enable:    () => createStdout(''),
        configure: (x) => this.sw1Configure(x),
        conf:      (x) => this.sw1Configure(x),
        exit:      () => this.sw1Exit(),
        end:       () => this.sw1End(),
        ip:        (x) => this.sw1Ip(x),
        no:        (x) => this.sw1No(x),
        interface: (x) => this.sw1Interface(x),
        int:       (x) => this.sw1Interface(x),
        show:      (x) => this.sw1Show(x),
        copy:      (x) => this.sw1Copy(x),
      },
    };
  },

  computed: {
    gw1Prompt() {
      const m = this.gw1.mode;
      if (m === 'config') return 'Gw1(config)#';
      if (m === 'config-line') return 'Gw1(config-line)#';
      if (m === 'config-ext-nacl') return 'Gw1(config-ext-nacl)#';
      if (m === 'config-if') return 'Gw1(config-if)#';
      return 'Gw1#';
    },
    sw1Prompt() {
      const m = this.sw1.mode;
      if (m === 'config') return 'Sw1(config)#';
      if (m === 'config-if') return 'Sw1(config-if)#';
      return 'Sw1#';
    },
    task1Done() {
      return ['username','lineVty','transportTelnet','loginLocal','vtyExited','endForVerify','verifyShowIp'].every(k => this.gw1Completion[k]);
    },
    task2Done() {
      return ['aclCreated','permitBootpc','permitBootps','permitHttps','denyIp','aclExited','intE00','accessGroup'].every(k => this.gw1Completion[k]);
    },
    task3Done() {
      return ['dhcpSnooping','dhcpSnoopingVlan','noInfoOption','verifyMac','intE01','trustE01','intE02','trustE02','endForVerify','verifyShow'].every(k => this.sw1Completion[k]);
    },
    saveDone() { return this.gw1Completion.saved && this.sw1Completion.saved; },
  },

  watch: {
    'gw1Completion.accessGroup'(val) { if (val) this.switchTo('sw1'); },
    'sw1Completion.saved'(val) { if (val && !this.gw1Completion.saved) this.switchTo('gw1'); },
  },

  mounted() {
    this.dataLocal.options.showMarkButton = false;
    this.$emit('simulation_update_options', this.dataLocal);
  },

  methods: {
    getState(k) { return this[k]; },
    getCompletion(k) { return this[k + 'Completion']; },

    guide(msg) {
      return `<span style="color:#28C76F;display:block;margin-top:6px;padding:4px 8px;border-left:2px solid #28C76F;font-size:0.85em;line-height:1.5">${msg}</span>`;
    },

    switchTo(dev) {
      this.sel = dev;
      this.$nextTick(() => {
        const el = document.querySelector(`#${dev}_terminal input, #${dev}_terminal textarea`);
        if (el) el.focus();
      });
    },

    modeErr(state, needed) {
      if (state.mode === needed) return null;
      if (needed === 'config') {
        if (state.mode === 'exec') return createStderr('% Must be in configuration mode — type "configure terminal" first');
        return createStderr('% Must be in configuration mode — type "exit" to leave current submode first');
      }
      if (needed === 'exec') return createStderr('% Must be in privileged EXEC mode — type "end" or "exit" first');
      if (needed === 'config-line') return createStderr('% Must be in line config mode — type "line vty 0 4" first');
      if (needed === 'config-ext-nacl') return createStderr('% Must be in ACL config mode — type "ip access-list extended CORP_ACL" first');
      if (needed === 'config-if') return createStderr('% Must be in interface config mode — type "interface [name]" first');
      return createStderr('% Invalid input detected');
    },

    updateScore() {
      let score = 0;
      [this.gw1Completion, this.sw1Completion].forEach(c => Object.values(c).forEach(v => { if (v) score++; }));
      this.totalScore = score;
      this.$forceUpdate();
      this.$emit('simulation_update_score', score);
      if (score >= 27) setTimeout(() => this.$emit('simulation_full_correct', score), 500);
    },

    // ── Gw1 methods ────────────────────────────────────────────────
    gw1Configure(x) {
      const me = this.modeErr(this.gw1, 'exec'); if (me) return me;
      if (x._[1] === 'terminal' || x._[1] === 't') {
        this.gw1.mode = 'config';
        return createStdout('Enter configuration commands, one per line.  End with CNTL/Z.');
      }
      return createStderr('% Invalid input detected');
    },

    gw1Exit() {
      const s = this.gw1; const c = this.gw1Completion;
      if (s.mode === 'config-line') {
        if (c.loginLocal && !c.vtyExited) { c.vtyExited = true; this.updateScore(); }
        s.mode = 'config';
        return createStdout(this.guide('Exited VTY config. → Next: type "end" to reach exec mode, then run "show ip interface brief" to confirm Gw1\'s IP address.'));
      }
      if (s.mode === 'config-ext-nacl') {
        if (c.denyIp && !c.aclExited) { c.aclExited = true; this.updateScore(); }
        s.mode = 'config'; s.currentAcl = null;
        return createStdout(this.guide('ACL entries finalized. → Next: "interface e0/0" to apply CORP_ACL inbound on the VLAN 10 interface.'));
      }
      if (s.mode === 'config-if') { s.mode = 'config'; return createStdout(''); }
      if (s.mode === 'config') {
        s.mode = 'exec'; s.endDone = true;
        if (c.vtyExited && !c.endForVerify) { c.endForVerify = true; this.updateScore(); }
        return createStdout(c.endForVerify ? this.guide('Back in exec mode. → Next: "show ip interface brief" to confirm Gw1\'s IP address.') : '');
      }
      return createStdout('');
    },

    gw1End() {
      const s = this.gw1; const c = this.gw1Completion;
      const wasConfig = s.mode !== 'exec';
      if (s.mode === 'config-line' && c.loginLocal && !c.vtyExited) { c.vtyExited = true; this.updateScore(); }
      if (s.mode === 'config-ext-nacl' && c.denyIp && !c.aclExited) { c.aclExited = true; this.updateScore(); }
      s.mode = 'exec';
      if (wasConfig) s.endDone = true;
      if (c.vtyExited && !c.endForVerify) { c.endForVerify = true; this.updateScore(); }
      return createStdout(c.endForVerify ? this.guide('Back in exec mode. → Next: "show ip interface brief" to confirm Gw1\'s IP address.') : '');
    },

    gw1Username(x) {
      const me = this.modeErr(this.gw1, 'config'); if (me) return me;
      const c = this.gw1Completion;
      if (x._[1] === 'wheel' && !c.username) {
        c.username = true; this.updateScore();
        return createStdout(this.guide('Created local user "wheel" with privilege 15 (full admin rights) using scrypt hashing — stronger than the default MD5. Privilege 15 means this user has all commands available without a separate enable password. → Next: configure VTY lines for telnet.'));
      }
      return createStdout('');
    },

    gw1Line(x) {
      const me = this.modeErr(this.gw1, 'config'); if (me) return me;
      const c = this.gw1Completion;
      if (x._[1] === 'vty') {
        this.gw1.mode = 'config-line';
        if (!c.lineVty) { c.lineVty = true; this.updateScore(); }
        return createStdout(this.guide('Entered VTY (virtual terminal) line configuration for lines 0-4 — the 5 simultaneous remote sessions this device supports. → Next: restrict these lines to telnet only.'));
      }
      return createStderr('% Invalid input detected');
    },

    gw1Transport(x) {
      const me = this.modeErr(this.gw1, 'config-line'); if (me) return me;
      const c = this.gw1Completion;
      if (x._[1] === 'input' && x._[2] === 'telnet' && !c.transportTelnet) {
        c.transportTelnet = true; this.updateScore();
        return createStdout(this.guide('VTY lines now accept Telnet only — SSH and other protocols are blocked. Note: Telnet sends credentials in plaintext; in production SSH is preferred, but this task specifically requires Telnet. → Next: require local account authentication.'));
      }
      return createStdout('');
    },

    gw1Login(x) {
      const me = this.modeErr(this.gw1, 'config-line'); if (me) return me;
      const c = this.gw1Completion;
      if (x._[1] === 'local' && !c.loginLocal) {
        c.loginLocal = true; this.updateScore();
        return createStdout(this.guide('VTY lines now authenticate against the local user database — the "wheel" account you created. Without this, anyone can connect without a password. → Next: type "exit" to leave VTY config.'));
      }
      return createStdout('');
    },

    gw1Ip(x) {
      const s = this.gw1; const c = this.gw1Completion;
      if (x._[1] === 'access-list' && x._[2] === 'extended') {
        const me = this.modeErr(s, 'config'); if (me) return me;
        s.mode = 'config-ext-nacl'; s.currentAcl = x._[3];
        if (!c.aclCreated) { c.aclCreated = true; this.updateScore(); }
        return createStdout(this.guide('Created extended named ACL "CORP_ACL". Extended ACLs filter on source IP, destination IP, protocol, and port — far more granular than standard ACLs which only match source address. → Next: add permit rules for DHCP traffic.'));
      }
      if (x._[1] === 'access-group') {
        const me = this.modeErr(s, 'config-if'); if (me) return me;
        if (x._[2] === 'CORP_ACL' && x._[3] === 'in' && !c.accessGroup) {
          c.accessGroup = true; this.updateScore();
          return createStdout(this.guide('CORP_ACL applied to e0/0 inbound. Traffic entering from VLAN 10 is now inspected: DHCP broadcasts allowed, HTTPS allowed, all other traffic denied and logged. "in" means the ACL evaluates packets as they arrive on this interface. → Move to Task 3: configure DHCP snooping on Sw1.'));
        }
        return createStdout('');
      }
      return createStderr('% Invalid input detected');
    },

    gw1Permit(x) {
      const me = this.modeErr(this.gw1, 'config-ext-nacl'); if (me) return me;
      const c = this.gw1Completion;
      if (x._[1] === 'udp' && x._[5] === 'bootpc' && !c.permitBootpc) {
        c.permitBootpc = true; this.updateScore();
        return createStdout(this.guide('Permitted DHCP client broadcasts (UDP port 68/bootpc) from any source to any destination. Clients use "any" because they have no IP yet when sending DHCP Discover. Without this rule, hosts on VLAN 10 can never obtain an IP address. → Next: permit DHCP server replies.'));
      }
      if (x._[1] === 'udp' && x._[5] === 'bootps' && !c.permitBootps) {
        c.permitBootps = true; this.updateScore();
        return createStdout(this.guide('Permitted DHCP server responses (UDP port 67/bootps). Covers Offer and Ack messages from the server back to clients. Both bootpc and bootps entries are required — missing either one breaks DHCP for the entire VLAN. → Next: permit HTTPS from the 10.10.10.0/24 subnet.'));
      }
      if (x._[1] === 'tcp' && !c.permitHttps) {
        c.permitHttps = true; this.updateScore();
        return createStdout(this.guide('Permitted HTTPS (TCP port 443) from the VLAN 10 subnet (10.10.10.0/24) to anywhere. Wildcard 0.0.0.255 matches all 256 host addresses in the /24. There\'s no "https" keyword in IOS ACLs — you must use port number 443. Only encrypted web traffic is allowed; plain HTTP (80) is blocked by the next deny rule. → Next: deny and log all other traffic.'));
      }
      return createStdout('');
    },

    gw1Deny(x) {
      const me = this.modeErr(this.gw1, 'config-ext-nacl'); if (me) return me;
      const c = this.gw1Completion;
      if (x._[1] === 'ip' && !c.denyIp) {
        c.denyIp = true; this.updateScore();
        return createStdout(this.guide('"deny ip" blocks all remaining IP traffic from VLAN 10. "log-input" enhances logging: it captures the ingress interface, source MAC address, and IP/port details — far more useful for forensics than plain "log" which only records IP addresses. The explicit deny makes blocked traffic visible in syslog; the implicit deny-all silently drops packets with no record. → Next: type "exit" to leave ACL config.'));
      }
      return createStdout('');
    },

    gw1Interface(x) {
      const s = this.gw1; const c = this.gw1Completion;
      if (s.mode !== 'config' && s.mode !== 'config-if') return this.modeErr(s, 'config');
      let _r1 = String(x._[1] || '');
      if (x._[2] && /^\d+\/\d+/.test(String(x._[2]))) _r1 = _r1 + x._[2];
      const raw = _r1.toLowerCase().replace(/^(ethernet|e|fastethernet|fa|f|gigabitethernet|gi)/, 'e')
      s.mode = 'config-if'; s.currentInterface = raw;
      if (raw === 'e0/0' && !c.intE00) {
        c.intE00 = true; this.updateScore();
        return createStdout(this.guide('Entered e0/0 — the interface facing VLAN 10 where HostA and HostC connect. This is where CORP_ACL must be applied inbound to filter their traffic at the point of entry. → Next: ip access-group CORP_ACL in'));
      }
      return createStdout('');
    },

    gw1Show(x) {
      const me = this.modeErr(this.gw1, 'exec'); if (me) return me;
      const c = this.gw1Completion;
      if (x._[1] === 'ip' && x._[2] === 'interface' && x._[3] === 'brief') {
        if (!c.verifyShowIp) { c.verifyShowIp = true; this.updateScore(); }
        return createStdout(SHOW_IFACE_BRIEF + this.guide('Gw1\'s interfaces confirmed: e0/0 is 10.1.1.1 (uplink/management) and e0/1 is 10.10.10.1 (VLAN 10 gateway). A client on VLAN 10 can now telnet to 10.1.1.1 using username "wheel" / password "lock3path". → Now configure the NACL in Task 2 — type "configure terminal" to return to config mode.'));
      }
      return createStderr('% Invalid input detected');
    },

    gw1Copy(x) {
      const me = this.modeErr(this.gw1, 'exec'); if (me) return me;
      const c = this.gw1Completion;
      if (x._[1] === 'running-config' && x._[2] === 'startup-config') {
        if (!c.saved) { c.saved = true; this.updateScore(); }
        return createStdout('Building configuration...<br>[OK]' + this.guide('Gw1 config saved to NVRAM — user account, VTY telnet settings, and CORP_ACL all persist across reboots.' + (this.saveDone ? ' ✓ Both devices saved — simulation complete!' : ' → Save Sw1 too.')));
      }
      return createStderr('% Invalid input detected');
    },

    // ── Sw1 methods ────────────────────────────────────────────────
    sw1Configure(x) {
      const me = this.modeErr(this.sw1, 'exec'); if (me) return me;
      if (x._[1] === 'terminal' || x._[1] === 't') {
        this.sw1.mode = 'config';
        return createStdout('Enter configuration commands, one per line.  End with CNTL/Z.');
      }
      return createStderr('% Invalid input detected');
    },

    sw1Exit() {
      const s = this.sw1; const c = this.sw1Completion;
      if (s.mode === 'config-if') { s.mode = 'config'; return createStdout(''); }
      if (s.mode === 'config') {
        s.mode = 'exec'; s.endDone = true;
        if (c.trustE02 && !c.endForVerify) { c.endForVerify = true; this.updateScore(); }
        return createStdout(c.endForVerify ? this.guide('Back in exec mode. → Next: "show ip dhcp snooping" to verify the full configuration.') : '');
      }
      return createStdout('');
    },

    sw1End() {
      const s = this.sw1; const c = this.sw1Completion;
      const wasConfig = s.mode !== 'exec';
      s.mode = 'exec';
      if (wasConfig) s.endDone = true;
      if (c.trustE02 && !c.endForVerify) { c.endForVerify = true; this.updateScore(); }
      return createStdout(c.endForVerify ? this.guide('Back in exec mode. → Next: "show ip dhcp snooping" to verify the full configuration.') : '');
    },

    sw1Ip(x) {
      const s = this.sw1; const c = this.sw1Completion;
      if (x._[1] !== 'dhcp' || x._[2] !== 'snooping') return createStderr('% Invalid input detected');
      const sub = x._[3];

      if (sub === undefined) {
        const me = this.modeErr(s, 'config'); if (me) return me;
        if (!c.dhcpSnooping) { c.dhcpSnooping = true; this.updateScore(); }
        return createStdout(this.guide('DHCP snooping enabled globally on Sw1. Snooping acts as a firewall for DHCP traffic — it inspects messages at the switch level and drops responses from untrusted ports, blocking rogue DHCP servers from hijacking client assignments. → Next: activate it for VLAN 10 specifically.'));
      }
      if (sub === 'vlan') {
        const me = this.modeErr(s, 'config'); if (me) return me;
        if (!c.dhcpSnoopingVlan) { c.dhcpSnoopingVlan = true; this.updateScore(); }
        return createStdout(this.guide('DHCP snooping activated for VLAN 10. Global enable alone does nothing — snooping must be specified per-VLAN. Since VLAN 10 is the client segment, this is where rogue DHCP attacks originate. → Next: disable Option 82 insertion.'));
      }
      if (sub === 'verify') {
        const me = this.modeErr(s, 'config'); if (me) return me;
        if (!c.verifyMac) { c.verifyMac = true; this.updateScore(); }
        return createStdout(this.guide('MAC address verification enabled. Snooping now cross-checks the source MAC in the Ethernet frame against the client hardware address in the DHCP packet. This defeats DHCP starvation attacks — a malicious client using fake MACs to exhaust the address pool will be blocked. → Next: configure trusted interfaces.'));
      }
      if (sub === 'trust') {
        const me = this.modeErr(s, 'config-if'); if (me) return me;
        const iface = s.currentInterface;
        if (iface === 'e0/1' && !c.trustE01) {
          c.trustE01 = true; this.updateScore();
          return createStdout(this.guide('e0/1 marked as trusted. DHCP server Offer and Ack messages arriving here are allowed through. On all untrusted ports (client-facing), any DHCP server response is silently dropped — preventing rogue servers from responding. → Next: trust e0/2 as well.'));
        }
        if (iface === 'e0/2' && !c.trustE02) {
          c.trustE02 = true; this.updateScore();
          return createStdout(this.guide('e0/2 marked as trusted. Both uplinks are now trusted — legitimate DHCP server traffic can flow. All remaining ports stay untrusted; clients on them can only send DHCP Discover/Request, never server responses. → Next: type "end" to return to exec mode, then verify with "show ip dhcp snooping".'));
        }
        return createStdout('');
      }
      return createStderr('% Invalid input detected');
    },

    sw1No(x) {
      const me = this.modeErr(this.sw1, 'config'); if (me) return me;
      const c = this.sw1Completion;
      if (x._[1] === 'ip' && x._[2] === 'dhcp' && x._[3] === 'snooping' && x._[4] === 'information') {
        if (!c.noInfoOption) { c.noInfoOption = true; this.updateScore(); }
        return createStdout(this.guide('Option 82 (DHCP relay agent information) insertion disabled. By default, snooping-enabled switches add Option 82 data to DHCP packets. When the DHCP server doesn\'t expect this extra data, it drops the request and clients get no IP address. Disabling ensures transparent DHCP forwarding in this topology. → Next: enable MAC address verification.'));
      }
      return createStderr('% Invalid input detected');
    },

    sw1Interface(x) {
      const s = this.sw1; const c = this.sw1Completion;
      if (s.mode !== 'config' && s.mode !== 'config-if') return this.modeErr(s, 'config');
      let _r1 = String(x._[1] || '');
      if (x._[2] && /^\d+\/\d+/.test(String(x._[2]))) _r1 = _r1 + x._[2];
      const raw = _r1.toLowerCase().replace(/^(ethernet|e|fastethernet|fa|f|gigabitethernet|gi)/, 'e')
      s.mode = 'config-if'; s.currentInterface = raw;
      if (raw === 'e0/1' && !c.intE01) {
        c.intE01 = true; this.updateScore();
        return createStdout(this.guide('Entered e0/1 — the interface connecting to the DHCP server or an upstream trusted switch. Ports facing legitimate DHCP servers must be marked trusted, otherwise the server\'s Offer/Ack responses will be dropped by snooping. → Next: ip dhcp snooping trust'));
      }
      if (raw === 'e0/2' && !c.intE02) {
        c.intE02 = true; this.updateScore();
        return createStdout(this.guide('Entered e0/2 — the second uplink/server-facing interface that also needs to be trusted. → Next: ip dhcp snooping trust'));
      }
      return createStdout('');
    },

    sw1Show(x) {
      const me = this.modeErr(this.sw1, 'exec'); if (me) return me;
      const c = this.sw1Completion;
      if (x._[1] === 'ip' && x._[2] === 'dhcp' && x._[3] === 'snooping') {
        if (!c.verifyShow) { c.verifyShow = true; this.updateScore(); }
        return createStdout(SHOW_DHCP_SNOOP + this.guide('DHCP snooping verified: globally enabled, active on VLAN 10, Option 82 disabled, MAC verification on, both uplinks trusted. Clients on untrusted ports are protected from rogue DHCP servers. → Save both device configs.'));
      }
      return createStderr('% Invalid input detected');
    },

    sw1Copy(x) {
      const me = this.modeErr(this.sw1, 'exec'); if (me) return me;
      const c = this.sw1Completion;
      if (x._[1] === 'running-config' && x._[2] === 'startup-config') {
        if (!c.saved) { c.saved = true; this.updateScore(); }
        return createStdout('Building configuration...<br>[OK]' + this.guide('Sw1 config saved to NVRAM — all DHCP snooping settings persist across reboots.' + (this.saveDone ? ' ✓ Both devices saved — simulation complete!' : ' → Save Gw1 too.')));
      }
      return createStderr('% Invalid input detected');
    },
  },

  components: { VueCommand },
  props: { data: { type: Object, required: true } },
};
</script>

<style>
#gw1_terminal, #sw1_terminal { overflow: hidden !important; }

.topology-card {
  margin-top: 1.5rem;
  background-color: #111111;
  border: 1px solid #181d2a;
  border-radius: 0.5rem;
  overflow: hidden;
  line-height: 0;
}
.topology-img {
  display: block;
  width: 100%;
  height: auto;
  max-width: 100%;
}
</style>

